import React, { useState, useEffect, lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import InfiniteScroll from "react-infinite-scroll-component";
import { moduleTagCategoryWithTags, resourcePlatforms } from '../utils';
import { useNavigate } from 'react-router-dom';
import logo from '../../Static/images/logo.png';
import Tooltip from '@mui/material/Tooltip';
import { History } from '../../Static/icons/iconshere';
import apiClient from '../../apiClient';
import { XR_MODULE_LIST } from '../../apiClient/apiEndpoints';
import { MODULE_LIMIT } from '../../constant/constant';

const PublishedList = ({ searchText, selectedCheckboxes, selectedCategoryCheckboxes }) => {
    const navigate = useNavigate();
    const configData = useSelector((state) => state.configSlice);
    const userData = useSelector((state) => state.userSlice);
    const tagsData = useSelector((state) => state.tagsSlice);
    const moduleData = useSelector((state) => state.moduleSlice);
    const [tagCategories, setTagCategories] = useState([]);

    const [list, setList] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [paginationPage, setPaginationPage] = useState(1);
    const [loading, setLoading] = useState(true);

    const getAllModuleList = async (pageId, searchQuery = null) => {
        let pageNumber = pageId || paginationPage;
        try {
            let data = await apiClient.get(`${configData.config.UNO_URL}${XR_MODULE_LIST}`, {
                params: {
                    limit: MODULE_LIMIT,
                    page: pageNumber,
                    search: searchQuery || null,
                    tagIds: selectedCheckboxes.map(e => e.id),
                    tagCategoryIds: selectedCategoryCheckboxes.map(e => e.id),
                }
            });
            setList((pre) => (pageNumber == 1 ? [...data] : [...pre, ...data]));
            setHasMore(data.length === MODULE_LIMIT);
            setPaginationPage(data.length === MODULE_LIMIT ? Number(pageNumber) + 1 : 1);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getAllModuleList(1, searchText);
    }, [searchText, selectedCheckboxes, selectedCategoryCheckboxes])

    useEffect(() => {
        if (tagsData?.allTagsList?.name) {
            let _data = moduleTagCategoryWithTags();
            setTagCategories([_data._sectorsList[0].categoryId, _data._packagesList[0].categoryId, _data._jobRolesTags[0].categoryId]);
        }
    }, [tagsData]);

    const loadMoreData = () => {
        getAllModuleList(paginationPage, searchText);
    };

    return (
        <>
            <div className='container-fluid px-4'>
                <div className='lowersection'>
                    <div className="scrollable-container">
                        <InfiniteScroll
                            scrollThreshold={0.7}
                            dataLength={list.length}
                            next={() => loadMoreData()}
                            hasMore={hasMore}
                            loader={<p> Fetching.... </p>}
                        >

                            {list.length > 0 ?
                                <>
                                    <div className='modulelist'>
                                        <div className="course-tiles">
                                            {list?.map((e, index) => {
                                                const MAX_TAGS_TO_DISPLAY = 2;
                                                const allTags = e.tags.filter(tag => tagCategories.includes(tag.categoryId));
                                                const displayedTags = allTags.slice(0, MAX_TAGS_TO_DISPLAY);
                                                const remainingTags = allTags.slice(MAX_TAGS_TO_DISPLAY);
                                                const remainingTagsCount = e.tags.filter(tag => tagCategories.includes(tag.categoryId)).length - displayedTags.length;
                                                const pathTagCategory = e.flowTagCategory.map(e => e.name).reverse();

                                                return (
                                                    <div className="tilecard" key={index + 1}>
                                                        <div className='modulecard module' onClick={() => navigate(`/dashboard/xr/details/${e.uuid}`, { state: { name: e.name, type: "MODULE", actionMode: "XR" } })}>
                                                            <div className='moduleicon'>
                                                                {e?.versions[0]?.data?.thumbnail ? (
                                                                    <img src={e.versions[0].data.thumbnail} alt="Thumbnail" />
                                                                ) : (
                                                                    <img src={logo} className='defaultimg' alt="Default Thumbnail" />
                                                                )}
                                                            </div>
                                                            <div className='moduledata'>
                                                                <Tooltip title={e?.name}>
                                                                    <p className='modulename'>{e?.name}</p>
                                                                </Tooltip>

                                                                <span className='selected-cate'>
                                                                    {pathTagCategory.length > 0 &&
                                                                        <Tooltip title={pathTagCategory.join(" > ")}>
                                                                            {pathTagCategory[0]}
                                                                        </Tooltip>
                                                                    }
                                                                </span>

                                                                <div className="detailtags pb-0" style={{ justifyContent: "center" }}>
                                                                    {displayedTags.map((tag, index) => {
                                                                        return (
                                                                            <React.Fragment key={index + 1}>
                                                                                <Tooltip title={tag.name}>
                                                                                    <p> {tag.name} </p>
                                                                                </Tooltip>

                                                                                <Tooltip title={remainingTags.map((remTag) => remTag.name).join(', ')} placement="top" arrow>
                                                                                    <span className='remainitmorebutton'>{index === MAX_TAGS_TO_DISPLAY - 1 && remainingTagsCount > 0 ? <p>+{remainingTagsCount} More</p> : null}</span>
                                                                                </Tooltip>
                                                                            </React.Fragment>
                                                                        );
                                                                    })}
                                                                </div>

                                                                <p className='moduledes'>{e?.versions[0]?.data?.short}</p>
                                                                <div className='moduleright'>
                                                                    <div className="devicelist">
                                                                        {e?.tags?.length > 0 && (
                                                                            <>
                                                                                {e.tags.map((tag, i) => {
                                                                                    const platformInfo = resourcePlatforms.find(platform => platform.name === tag.name);
                                                                                    return platformInfo ? (
                                                                                        <Tooltip key={i} title={platformInfo.name} placement="top" arrow>
                                                                                            <img src={platformInfo.icon} alt={platformInfo.name} />
                                                                                        </Tooltip>
                                                                                    ) : null;
                                                                                })}
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {e?.activities?.length > 0 && <Tooltip title={
                                                            <span style={{ whiteSpace: 'pre-line' }}>
                                                                Last Updated : {moment(e.activities[0].createdAt).format('lll')} {'\n'}
                                                                {/* Published By : MD Sohail */}
                                                            </span>
                                                        }>
                                                            <span className='last-info' >  <History /> </span>
                                                        </Tooltip>}
                                                    </div>
                                                )
                                            })
                                            }
                                        </div>
                                    </div>
                                </>
                                :
                                <div className='modulelist'>
                                    <p> No Module Found </p>
                                </div>
                            }

                        </InfiniteScroll>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PublishedList;